import type { Configuration } from 'modules/integrations/public'

export const COMPENSATIONS_SYNC_CONFIGURATION: Configuration = {
  origin: 'compensations',
  syncableStatesAggregation: (syncableState) => {
    const syncable = syncableState.syncable
    if (!syncable) {
      throw new Error('syncable must be present in Compensations status aggregation')
    }

    return syncable.payrollRunEmployeeId
  },
}
